import { DefaultMinQuantityStrategy } from './default';
import { RAFMinQuantityStrategy } from './raf';
import type { MinQuantityStrategyMap } from './types';

export const strategies: MinQuantityStrategyMap = {
  default: DefaultMinQuantityStrategy,
  RAF: RAFMinQuantityStrategy,
};
